
import axios from 'axios';

export const saveInfo = (data) => {
  // http://app-gateway-op-test.zmlearn.com/api/teacher-peilian/v1/tcp
  // https://app-gateway-internal-ng.zmlearn.com/api/teacher-peilian/v1/tcp
  return axios({
    method: 'post',
    url: '/api/teacher-peilian/v1/tcp/updateTeacher',
    timeout: 1000,
    headers: {accessToken: data.token},
    data,
  });
};

export const getPeilianTeacherInfoNew = (options) => {
  return axios({
    method: 'post',
    url: '/api/teacher-peilian/v1/tcp/getTeacher',
    timeout: 1000,
    headers: {accessToken: options.token},
    data: {},
  });
};

// export const upload = (options) => {
//     // https://v2-test-internal.zmaxis.com/api
//     // https://www-internal-ng.zhangmen.com/api
//     return axios.post('/api/teacher/upload-peilian-detail', options);
// };


export const validateTeacherCode = (options) => {
  // http://app-gateway-test.zmlearn.com/api/operation-web-server/v1/ow
  // https://app-gateway-internal-ng.zmlearn.com/api/operation-web-server/v1/ow
  return axios({
    method: 'post',
    url: '/v1/ow/validateTeacherCode',
    timeout: 1000,
    data: options,
  });
};

export const teacherRegister = (options) => {
  return axios({
    method: 'post',
    url: 'https://v2-test-internal.zmaxis.com/api/teacher/register',
    timeout: 1000,
    data: options,
  });
};